import { useContext } from "react";
import FormContext, { type FormContextValue } from "../contexts/FormContext";

export function useForm(): FormContextValue {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
}
